export default __webpack_public_path__ + "static/media/active_like_btn.8121a3ce.svg";